<app-header></app-header>
<ion-content
  id="deals"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <app-page-title-banner
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    [pageTitle]="'i18n.deals.dealsTitle' | translate"
    [backgroundImageStyle]="backgroundImageStyle"
    [overlayGradient]="overlayGradient"
    [showEllipsis]="false"
  ></app-page-title-banner>

  <ion-grid class="deals-content" [fixed]="true">
    <ion-row>
      <ion-col>
        <app-deals-banner
          *ngIf="showAllDealsBanner"
          [bannerStyle]="'allDeals'"
          [textOne]="'i18n.deals.allDealsBannerTitleOne'"
          [textTwo]="'i18n.deals.allDealsBannerTitleTwo'"
          [textThree]="'i18n.deals.allDealsBannerText'"
          [buttonText]="'i18n.deals.allDealsBannerButtonText'"
          [buttonLink]="allDealsPath"
        >
        </app-deals-banner>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-deals-banner
          [bannerStyle]="'whileSupplies'"
          [textOne]="'i18n.deals.whileSuppliesTitleOne'"
          [textFour]="'i18n.deals.whileSuppliesTitleTwo'"
          [textTwo]="'i18n.deals.whileSuppliesTextOne'"
          [textThree]="'i18n.deals.whileSuppliesTextTwo'"
          [buttonText]="'i18n.deals.whileSuppliesButtonText'"
          [buttonLink]="whileSuppliesCode"
          [isNewSearchEnabled]="isNewSearchEnabled$ | async"
        >
        </app-deals-banner>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="revManWinbacks?.length > 0">
      <ion-col>
        <app-merchandising-product-carousel
          observeIntersection
          [platformType]="platformService?.platformType"
          [title]="'i18n.deals.revManWinbacksTitle' | translate"
          [products]="revManWinbacks"
          [linkSource]="revManLnkSrc"
          [merchFeature]="WIN_BACKS_FEATURE"
          [addMethod]="WIN_BACKS_FEATURE"
          (quantityUpdateEmitter)="onRevManWinbackQuantityUpdate($event.quantityUpdate, $event.index)"
          (impression)="onRevManWinbacksView()"
        >
        </app-merchandising-product-carousel>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-deals-banner
          [bannerStyle]="'scoop'"
          [buttonLink]="newScoopSearchKey"
          [isNewSearchEnabled]="isNewSearchEnabled$ | async"
        >
        </app-deals-banner>
      </ion-col>
    </ion-row>
  </ion-grid>

  <app-footer></app-footer>
</ion-content>
